import type { SVGProps } from '@/types/common.types';

const AmediatekaSecondarySVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="126"
      height="16"
      viewBox="0 0 126 12"
      fill="none"
      {...props}
    >
      <path
        d="M8.57252 10.4152H3.34041L2.54347 12H0L5.95796 0L11.9144 12H9.36871L8.57177 10.4152H8.57252ZM4.36109 8.3505H7.53014L5.93401 5.163L4.36109 8.3505ZM20.3986 8.68875L17.166 5.715V12H14.6891V0L20.3814 5.3415L26.1433 0V12H23.6762V5.715L20.3986 8.68875ZM38.9243 2.742H33.3914V4.96725H38.393V7.281H33.3914V9.684H39.0073V11.9977H30.9152V0.4275H38.9243V2.742ZM53.0469 6.285C53.0469 9.6675 50.591 12 46.878 12H43.2023V0.4305H46.985C50.7324 0.42675 53.0469 2.8665 53.0469 6.285ZM50.5731 6.21375C50.5731 4.029 49.1588 2.7435 47.1436 2.7435H45.6754V9.68475H47.1256C49.1049 9.68475 50.5731 8.403 50.5731 6.21375ZM55.9459 0.4275H63.0524V2.7405H60.7357V9.6825H63.0524V11.9963H55.9459V9.6825H58.2626V2.7405H55.9459V0.4275ZM74.1175 10.4152H68.8847L68.09 12H65.5376L71.4948 0L77.4527 12H74.9003L74.1175 10.4152ZM69.9061 8.3505H73.0699L71.4783 5.163L69.9061 8.3505ZM77.6877 0.4275H87.5862V2.7405H83.8754V11.9963H81.4V2.74125H77.6877V0.426V0.4275ZM98.7935 2.742H93.2605V4.96725H98.2637V7.281H93.2605V9.684H98.8765V11.9977H90.7807V0.4275H98.7882L98.7935 2.742ZM105.546 6.6405V12H103.071V0.4305H105.546V5.595L109.469 0.43125H112.457L108.165 6.036L112.85 12H109.898L105.546 6.6405ZM122.374 10.4152H117.142L116.346 12H113.8L119.758 0L125.714 12H123.169L122.374 10.4152ZM118.162 8.3505H121.328L119.736 5.163L118.162 8.3505Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AmediatekaSecondarySVG;
